import React from 'react';
import './SaveAddressSuccess.scss';

const SaveAddressSuccess = (
  <div className="address-success_modal">
    <img
      src="https://act.ecovision.gtimg.com/static/imgs/static/static_1760435721708.png"
      className="address-success_modal__icon"
    />
    <div className="address-success_modal__title">地址已填写成功</div>
    <div className="address-success_modal__content">请您留意后续快递到货信息</div>
    <div className="address-success_modal__tips">
      <img
        className="address-success_modal__tips--icon"
        src="https://obd.gtimg.com/flow/static/assets/8a2f8e7463324881bad7f0476b0fc49da4e057f8.svg"
      />
      <div className="address-success_modal__tips--content">如需修改地址请联系福利鹅公众号客服</div>
    </div>
  </div>
);

export default SaveAddressSuccess;
